import './styles/BlogCard.scss';
import { BlogPostPreview, czechDate, excerpt } from './blogUtils';
import { resolveBlogImage } from '../Constants';

interface BlogCardProps {
    post: BlogPostPreview;
    onClick: () => void;
    featured?: boolean;
}

export default function BlogCard({ post, onClick, featured }: BlogCardProps) {
    // Render a real <a href> so it's a crawlable link (react-snap prerender, SEO,
    // open-in-new-tab), but keep SPA navigation on normal click via onClick.
    return (
        <a
            className={"blogCard" + (featured ? " featured" : "")}
            href={`/blog/${post.url}`}
            onClick={(e) => { e.preventDefault(); onClick(); }}
        >
            <div className="thumb">
                <img src={resolveBlogImage(post.image)} alt="" loading="lazy" />
                <span className="date">{czechDate(post.timeStamp)}</span>
            </div>
            <div className="content">
                <h3>{post.heading}</h3>
                <p className="excerpt">{excerpt(post.description, featured ? 280 : 150)}</p>
                <span className="more">
                    Číst článek
                    <i className="chevron" />
                </span>
            </div>
        </a>
    );
}
